import { render, staticRenderFns } from "./CreatePrivateRateGoals.vue?vue&type=template&id=318f3556&scoped=true&"
import script from "./CreatePrivateRateGoals.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreatePrivateRateGoals.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CreatePrivateRateGoals.vue?vue&type=style&index=0&id=318f3556&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f3556",
  null
  
)

export default component.exports